import { render } from "./mybooking-court.vue?vue&type=template&id=2ee641f4"
import script from "./mybooking-court.vue?vue&type=script&lang=js"
export * from "./mybooking-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__